import { Tag } from '../../cdl/Tag/Tag';
import { Text } from '../../cdl/Text/Text';
import { translate } from '../../common/helpers/translate.helper';
import { Box } from '../../common/ui/Box';

interface SsoHeaderProps {
    connectionId: string;
}

export const SsoHeader = ({ connectionId }: SsoHeaderProps) => {
    return (
        <Box display="flex" flexDirection="column" gap={8}>
            <Text variant="title" as="h2">
                {translate('sso.groupsHeadline')}
            </Text>
            <Text variant="body" color="foreground.subtle">
                {translate('sso.groupsSubheadlinePrefix')} <Tag variant="default">{connectionId}</Tag>
            </Text>
        </Box>
    );
};
